import { render, staticRenderFns } from "./RingbaIntegrationBanner.vue?vue&type=template&id=0adc65e8&scoped=true"
import script from "./RingbaIntegrationBanner.vue?vue&type=script&lang=js"
export * from "./RingbaIntegrationBanner.vue?vue&type=script&lang=js"
import style0 from "./RingbaIntegrationBanner.vue?vue&type=style&index=0&id=0adc65e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc65e8",
  null
  
)

export default component.exports